import { Router } from 'vue-router';

let globalRouter: Router | null = null;

export function setRouter(r: Router) {
  globalRouter = r;
}

export function getRouter(): Router | null {
  return globalRouter;
}
